import * as React from 'react'
import { Trans } from '@lingui/macro'
import { Container, Grid, GridCol } from '../../ui-kit'

export const PageSupportedBrowsers = () => {
  return (
    <Container>
      <Grid>
        <GridCol size={{ s: 10, m: 8, l: 8, xl: 8 }}>
          <h1 style={{ marginTop: 24 }} className="h2 mb-xxlarge">
            <Trans>Podporované webové prehliadače:</Trans>
          </h1>
          <Trans>
            Webová lokalita up-dejeuner.sk využíva najnovšie štandardy zabezpečenia a šifrovania,
            aby bolo vaše prehliadanie a objednávanie bezpečné a príjemné. Na prezeranie stránok
            môžete použiť ktorýkoľvek z týchto webových prehliadačov:
          </Trans>
          <div style={{ marginTop: 8, marginBottom: 8 }}>
            <ul>
              <li>
                <Trans>Chrome 72+</Trans>
              </li>
              <li>
                <Trans>Firefox 65+</Trans>
              </li>
              <li>
                <Trans>Internet Explorer 12+</Trans>
              </li>
              <li>
                <Trans>Safari 12+</Trans>
              </li>
              <li>
                <Trans>Edge 18+</Trans>
              </li>
              <li>
                <Trans>iOS Safari 12+</Trans>
              </li>
              <li>
                <Trans>Android Browser 67+</Trans>
              </li>
            </ul>
          </div>
          <Trans>
            Odporúčame, aby ste si nainštalovali najnovšiu dostupnú verziu webového prehliadača a
            pravidelne aktualizovali operačný systém prostredníctvom najnovších aktualizácií
            zabezpečenia. Po aktualizácii na podporovaný prehliadač môže byť potrebné aktualizovať
            predvoľby prehliadača povolením súborov cookies, jazyka JavaScript a protokolu TLS 1.2.
            Tieto nastavenia nájdete v ponuke možností prehliadača.
          </Trans>
          <h1 style={{ marginTop: 24 }} className="h2 mb-xxlarge">
            <Trans>Podporované mobilné operačné systémy pre mobilnú aplikáciu Zóna Up</Trans>
          </h1>
          <div style={{ marginBottom: 80 }}>
            <ul>
              <li>
                <Trans>iOS 9+</Trans>
              </li>
              <li>
                <Trans>Android 5+</Trans>
              </li>
            </ul>
          </div>
        </GridCol>
      </Grid>
    </Container>
  )
}
